/**
 * HandsFreeToggle
 *
 * Small pill toggle for the hands-free voice navigation mode, shown in the
 * header of the between-conversation screens (episode-ready, waiting). Toggling
 * persists the preference and (on the ready screen) also switches the upcoming
 * conversation to voice/VAD input.
 */

interface HandsFreeToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  className?: string;
}

export default function HandsFreeToggle({ enabled, onChange, className = '' }: HandsFreeToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      onClick={() => onChange(!enabled)}
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-full border text-sm font-medium transition-all ${
        enabled
          ? 'bg-primary text-white border-primary shadow-sm'
          : 'bg-white dark:bg-white/10 text-gray-600 dark:text-white/80 border-gray-200 dark:border-white/20 hover:border-primary/50'
      } ${className}`}
      title={enabled ? 'Desligar modo mãos-livres' : 'Ligar modo mãos-livres (lê e ouve por voz)'}
    >
      {/* Steering-wheel / voice glyph */}
      <span aria-hidden className="text-base leading-none">🚗</span>
      <span>Mãos-livres</span>
      <span
        aria-hidden
        className={`ml-1 w-8 h-4 rounded-full relative transition-colors ${
          enabled ? 'bg-white/40' : 'bg-gray-300 dark:bg-white/20'
        }`}
      >
        <span
          className={`absolute top-0.5 w-3 h-3 rounded-full bg-white shadow transition-all ${
            enabled ? 'left-4' : 'left-0.5'
          }`}
        />
      </span>
    </button>
  );
}
